const handleAxiosError = function(error){
    if(error && error.response && error.response.data){
       return error.response.data; 
    }
    return error;
}

const handleAxiosResponse = function(resp) {
    if(resp){
        return resp.data;
    }
    return resp;
}

export {
    handleAxiosResponse,
    handleAxiosError
}